import type { DateTime } from 'luxon';
import { TaggedUnion } from 'type-fest';
import type { Frequency } from './frequency';

export type DaysOfWeekShort = 'MO' | 'TU' | 'WE' | 'TH' | 'FR' | 'SA' | 'SU';

export type RecurrenceType = {
  dueOn?: DateTime;
  endOn?: DateTime | null;
  frequency?: Frequency;
  interval?: number;
  count?: number | null;
  byMonthDay?: number[] | null;
  byDay?: DaysOfWeekShort[] | null;
  bySetPos?: number[] | null;
  byMonth?: number[] | null;
  byYearDay?: number[] | null;
  byDates?: string[] | null;
  alias?: string | null;
  isValid?: boolean;
};

export type RecurrenceWithDates = {
  recurrence: RecurrenceType;
  startDate: DateTime;
  endDate?: DateTime;
};

// actions
export const UPDATE_ALIAS = 'UPDATE_ALIAS';
export const CLEAR_STATE = 'CLEAR_STATE';
export const UPDATE_ONE_TIME = 'UPDATE_ONE_TIME';
export const UPDATE_FREQUENCY_EVERY_X_DAYS = 'UPDATE_FREQUENCY_EVERY_X_DAYS';
export const UPDATE_FREQUENCY_MONTHLY = 'UPDATE_FREQUENCY_MONTHLY';
export const UPDATE_FREQUENCY_EVERY_X_MONTHS = 'UPDATE_FREQUENCY_EVERY_X_MONTHS';
export const UPDATE_FREQUENCY_WEEKLY = 'UPDATE_FREQUENCY_WEEKLY';
export const UPDATE_FREQUENCY_EVERY_X_WEEKS = 'UPDATE_FREQUENCY_EVERY_X_WEEKS';
export const UPDATE_FREQUENCY_EVERY_X_YEARS = 'UPDATE_FREQUENCY_EVERY_X_YEARS';
export const UPDATE_FREQUENCY_90_DAYS = 'UPDATE_FREQUENCY_90_DAYS';
export const UPDATE_FREQUENCY_3_MONTHS = 'UPDATE_FREQUENCY_3_MONTHS';
export const UPDATE_FREQUENCY_YEARLY = 'UPDATE_FREQUENCY_YEARLY';
export const UPDATE_WEEKLY_BY_DAY = 'UPDATE_WEEKLY_BY_DAY';
export const UPDATE_MONTHLY_BY_WEEKDAY = 'UPDATE_MONTHLY_BY_WEEKDAY';
export const UPDATE_MONTHLY_BY_DAYS_IN_MONTH = 'UPDATE_MONTHLY_BY_DAYS_IN_MONTH';
export const UPDATE_MONTHLY_BY_MONTHDAY = 'UPDATE_MONTHLY_BY_MONTHDAY';
export const UPDATE_MONTHLY_BY_DAY_OF_WEEK = 'UPDATE_MONTHLY_BY_DAY_OF_WEEK';
export const UPDATE_EVERY_X_INTERVAL = 'UPDATE_EVERY_X_INTERVAL';
export const UPDATE_YEARLY_MONTHS = 'UPDATE_YEARLY_MONTHS';
export const UPDATE_MULTIPLE_BY_DATES = 'UPDATE_MULTIPLE_BY_DATES';
export const UPDATE_DUE_ON = 'UPDATE_DUE_ON';
export const UPDATE_DEFAULT = 'UPDATE_DEFAULT';
export const VALIDATE_RECURRENCE = 'VALIDATE_RECURRENCE';

export type FrequencyAction = TaggedUnion<
  'type',
  {
    UPDATE_ALIAS: { payload: string };
    CLEAR_STATE: { payload: undefined };
    UPDATE_ONE_TIME: { payload: DateTime };
    UPDATE_FREQUENCY_EVERY_X_DAYS: { payload: { interval: number | undefined } };
    UPDATE_FREQUENCY_MONTHLY: { payload: number[] | undefined | null };
    UPDATE_FREQUENCY_EVERY_X_MONTHS: { payload: { interval: number | undefined } };
    UPDATE_FREQUENCY_WEEKLY: { payload: DaysOfWeekShort[] | null | undefined };
    UPDATE_FREQUENCY_EVERY_X_WEEKS: { payload: number };
    UPDATE_FREQUENCY_EVERY_X_YEARS: { payload: { interval: number | undefined } };
    UPDATE_FREQUENCY_90_DAYS: { payload: undefined };
    UPDATE_FREQUENCY_3_MONTHS: { payload: undefined };
    UPDATE_FREQUENCY_YEARLY: { payload: undefined };
    UPDATE_WEEKLY_BY_DAY: { payload: DaysOfWeekShort[] | null | undefined };
    UPDATE_MONTHLY_BY_WEEKDAY: { payload: DaysOfWeekShort[] | null | undefined };
    UPDATE_MONTHLY_BY_DAYS_IN_MONTH: { payload: number[] | undefined | null };
    UPDATE_MONTHLY_BY_MONTHDAY: { payload: number[] | undefined | null };
    UPDATE_MONTHLY_BY_DAY_OF_WEEK: {
      payload: { dayOfWeek: DaysOfWeekShort[] | null | undefined; occurences: number[] | undefined | null };
    };
    UPDATE_EVERY_X_INTERVAL: { payload: number | undefined };
    UPDATE_YEARLY_MONTHS: { payload: { months: number[] | null | undefined } };
    UPDATE_MULTIPLE_BY_DATES: { payload: string[] | null | undefined };
    UPDATE_DUE_ON: { payload: DateTime };
    UPDATE_DEFAULT: { payload: { alias: string; dueOn: DateTime; endOn: DateTime | undefined } };
    VALIDATE_RECURRENCE: { payload: undefined };
  }
>;
